import { render, staticRenderFns } from "./TicketArchive.vue?vue&type=template&id=96ef5db6"
import script from "./TicketArchive.vue?vue&type=script&lang=js"
export * from "./TicketArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports